import { HiUserGroup } from 'react-icons/hi'
import { BsFillPatchCheckFill } from 'react-icons/bs'

import './asideright.css'
import UserAppContext from '../../hook/UserAppContext'

const AsideRight = () => {

      const {user} = UserAppContext()
      const {friends} = user.user 

      if(friends.data) return

      return (
            <div className="main_aside__right">
                  <div className="box_wrapper">
                        <div className="header_box__content">
                              <div className="header_content_icon">
                                    <HiUserGroup />
                              </div>
                              <h3>Friends</h3>
                        </div>
                        <div className="box_content">
                              <div className="box_friends">
                                    {
                                          friends.map((item) => (
                                                <div className="friend_rows" key={item.name}>
                                                      <div className="friend_avatar">
                                                            <div className="friend_avatar_img">
                                                                  <img src={item.avatar} alt={item.name} />
                                                            </div>
                                                            <div className="friend_avatar__icon">
                                                                  <BsFillPatchCheckFill />
                                                            </div>
                                                      </div>
                                                      <div className="friend_data">
                                                            <div className="friend_data__infor">
                                                                  <h5>{item.name}</h5>
                                                                  <p>{item.description}</p>
                                                            </div>
                                                            <a href={item.me} target="_blank" rel="noreferrer">xat.me</a>
                                                      </div>
                                                </div>
                                          ))
                                    }
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default AsideRight